"use client";

import { Moon, Sun } from "@/components/icons";
import { usePrefersLight, setTheme } from "@/hooks/use-color-scheme";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
}

/** Icon shows the theme a click switches TO the OPPOSITE of, i.e. it mirrors
 *  the currently active theme (moon while dark, sun while light). */
export function ThemeToggle({ className }: Props) {
  const prefersLight = usePrefersLight();

  return (
    <button
      type="button"
      onClick={() => setTheme(prefersLight ? "dark" : "light")}
      aria-label={prefersLight ? "Switch to dark theme" : "Switch to light theme"}
      className={cn("rounded-md p-2 transition-colors", className)}
    >
      {prefersLight ? (
        <Sun className="size-4" aria-hidden="true" />
      ) : (
        <Moon className="size-4" aria-hidden="true" />
      )}
    </button>
  );
}
